import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';


class ProductRowItem extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { product } = this.props;
        const productSlug = `/app/products/${ product.desireid }/${ encodeForURI(product.title) }`;

        return (
            <div
            className={ `${ style.productRowItem } ${ this.props.className }` }
            style={ { ...this.props.style } }
            data-hook='product-row-item'>
                <Link to={ productSlug }>
                    <div className={ style.imageWrapper }>
                        <img src={ product.image } />
                    </div>
                    <div className={ style.details }>
                        <div className={ style.listTitle } title={ product.title }>{ product.title }</div>
                        <div className={ style.listPrice } title={ `\$${ product.price }` }>{ `\$${ product.price }` }</div>
                    </div>
                </Link>
            </div>
        );
    }
}
ProductRowItem.propTypes = {
    product: PropTypes.object.isRequired,
};

export default connect()( ProductRowItem );
